<template>
  <div class="itinerary-section-item-statuses">
    <div v-if="statuses.accessType">
      <EntityAccessTypeIcon class="access-type" :type="statuses.accessType.type" />
    </div>
    <div v-if="statuses.activityStatus" class="text-statuses">
      <div class="text-status text-status--activity">
        {{ statuses.activityStatus }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    EntityAccessTypeIcon: () => import('@/components/icons/EntityAccessTypeIcon.vue'),
  },
  props: {
    statuses: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables-site/variables' as vars;

.itinerary-section-item-statuses {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
  gap: 16px;

  @media (min-width: vars.$mobile-break-point + 1px) {
    width: 100%;
    justify-content: flex-end;
    gap: 32px;
  }

  .access-type {
    width: 24px;
    height: 24px;

    @media (min-width: vars.$mobile-break-point + 1px) {
      width: 32px;
      height: 32px;
    }

    svg {
      width: 100%;
      height: 100%;
    }
  }

  .text-statuses {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: flex-end;
    gap: 16px;

    @media (min-width: vars.$mobile-break-point + 1px) {
      width: auto;
      gap: 32px;
    }
  }

  .text-status {
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0.15em;
    text-transform: uppercase;
    white-space: nowrap;

    @media (min-width: vars.$mobile-break-point + 1px) {
      font-size: 16px;
    }

    &--activity {
      color: vars.$c-link-7b;
    }
  }
}
</style>
